/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgencyAsFreelancerResource
 */
export interface AgencyAsFreelancerResource {
    /**
     * 
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    nafCode: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    idcc?: string;
    /**
     * Workforce range (e.g. BETWEEN_11_AND_49)
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    companySize?: string;
    /**
     * Current identity type (FREELANCE or SUBCONTRACTOR)
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    identityType: string;
    /**
     * Number of projects in the last 12 months (from BigQuery)
     * @type {number}
     * @memberof AgencyAsFreelancerResource
     */
    nbProjectsLast12m?: number;
    /**
     * Date of the most recent project (from BigQuery)
     * @type {Date}
     * @memberof AgencyAsFreelancerResource
     */
    lastProjectDate?: Date;
    /**
     * Total GSV in the last 12 months (from BigQuery)
     * @type {number}
     * @memberof AgencyAsFreelancerResource
     */
    gsvLast12m?: number;
    /**
     * Email domain of the freelancer account (extracted from the company email)
     * @type {string}
     * @memberof AgencyAsFreelancerResource
     */
    domainName?: string;
    /**
     * True if the company is an umbrella company (portage salarial)
     * @type {boolean}
     * @memberof AgencyAsFreelancerResource
     */
    isUmbrella: boolean;
}

/**
 * Check if a given object implements the AgencyAsFreelancerResource interface.
 */
export function instanceOfAgencyAsFreelancerResource(value: object): value is AgencyAsFreelancerResource {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('nafCode' in value) || value['nafCode'] === undefined) return false;
    if (!('identityType' in value) || value['identityType'] === undefined) return false;
    if (!('isUmbrella' in value) || value['isUmbrella'] === undefined) return false;
    return true;
}

export function AgencyAsFreelancerResourceFromJSON(json: any): AgencyAsFreelancerResource {
    return AgencyAsFreelancerResourceFromJSONTyped(json, false);
}

export function AgencyAsFreelancerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyAsFreelancerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
        'nafCode': json['nafCode'],
        'idcc': json['idcc'] == null ? undefined : json['idcc'],
        'companySize': json['companySize'] == null ? undefined : json['companySize'],
        'identityType': json['identityType'],
        'nbProjectsLast12m': json['nbProjectsLast12m'] == null ? undefined : json['nbProjectsLast12m'],
        'lastProjectDate': json['lastProjectDate'] == null ? undefined : (new Date(json['lastProjectDate'])),
        'gsvLast12m': json['gsvLast12m'] == null ? undefined : json['gsvLast12m'],
        'domainName': json['domainName'] == null ? undefined : json['domainName'],
        'isUmbrella': json['isUmbrella'],
    };
}

export function AgencyAsFreelancerResourceToJSON(value?: AgencyAsFreelancerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'nafCode': value['nafCode'],
        'idcc': value['idcc'],
        'companySize': value['companySize'],
        'identityType': value['identityType'],
        'nbProjectsLast12m': value['nbProjectsLast12m'],
        'lastProjectDate': value['lastProjectDate'] == null ? undefined : ((value['lastProjectDate'] as any).toISOString().substring(0,10)),
        'gsvLast12m': value['gsvLast12m'],
        'domainName': value['domainName'],
        'isUmbrella': value['isUmbrella'],
    };
}

